import { lazy, useEffect, Suspense, useRef, useState } from "react";
import { useSelector } from "react-redux";
import WSocketService from "../../services/websocket.service";
import Loader from "../Loader";
import './toolbar.css'
import { finalRecording, getAgentData, getAgentMonitorSdk, getParam, getRoleStatus, getScreenRecordingMode, handleScreenRecording, isSettingEnabled, isUcidRecordingMode, registerAgentMonitorSdk } from "../../services/util";
import { handleAgentLogoffByAdmin } from "../../services/authService";
import LocalStorageService from "../../services/localstorage.service";
import { setHomePageLogo, setScreenRecordCancelled, setScreenRecording } from "../../context/toolbarSlice";
import HttpService from "../../services/http.service";
import { store } from "../../context/store";
import { setActiveTab, setVisibleTabs } from "../../context/dashboardSlice";
import { showErrorNotification, showSuccessNotification } from "../common/NotiService";
import CallAudioElements from "./CallAudioElements";
import useBrowserEvent from "../../hooks/useBrowserEvent";
import Logger from "../../services/logger.service";
import { PostScreenPop } from "../ScreenPop";
import ChatApp from "../chat/ChatApp";
import { callControlsJsonList, setScreenRecordingClientId } from "../../services/agent.service";
import { useNavigate } from "react-router-dom";
import NavigatorBinder from "../NavigatorBinder";
import Clarity from "@microsoft/clarity";
import { app } from '../../config';

const StatusBar = lazy(() => import('../StatusBar'));
const ModesList = lazy(() => import('../ModesList'));
const DynamicContainer = lazy(() => import('../DynamicContainer'));
const SideNav = lazy(() => import('../SideNav'));
const DashboardTabs = lazy(() => import('../DashboardTabs'));
const MinimizedCallView = lazy(() => import('../CallView/MinimizedCallView'));
const TBMinimizer = lazy(() => import('../MiniMode').then((module) => { return { default: module.TBMinimizer } }));

function Toolbar() {
    const isTbMinimized = useSelector((state) => state.toolbar.isTbMinimized)
    const agentLogoffByAdmin = useSelector((state) => state.toolbar.agentLogoffByAdmin);
    const isWebsocketConnected = useSelector((state) => state.toolbar.isWebsocketConnected);
    const INTERNET_CHECK_ALERT = getParam('INTERNET_CHECK_ALERT') === "true";
    let AGENT_SUB_USER_CHAT = isSettingEnabled("AGENT_SUB_USER_CHAT");
    const SCREEN_RECORD_BY_APP = isSettingEnabled("SCREEN_RECORD_BY_APP");
    const usId = useSelector((state) => state.toolbar.usId);
    const parentRef = useRef(null);
    const [position, setPosition] = useState({ x: 340, y: 250 });
    const [isDragging, setIsDragging] = useState(false);
    const [startPosition, setStartPosition] = useState({ x: 0, y: 0 });

    const ROLE_SCREEN_RECORDING = getRoleStatus("ROLE_SCREEN_RECORDING");
    let agentData = getAgentData();
    const isAgantScreenRecordingEnabled = agentData?.agentInfo?.screenRecording ?? false;
    const isScreenRecordingEnabledByApp = useSelector((state) => state.toolbar.isScreenRecordingEnabledByApp);
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (SCREEN_RECORD_BY_APP) {
    //         setScreenRecordingClientId(usId);
    //     }
    // }, [usId]);

    //To handle browser events
    useBrowserEvent()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (ROLE_SCREEN_RECORDING && !SCREEN_RECORD_BY_APP && !getAgentMonitorSdk()) {
            const recordingMode = getScreenRecordingMode();
            console.log("screen recording toolbar.jsx: final recordingMode ", recordingMode);
            const sdk = new window.AgentMonitorSDK({
                endpoint: HttpService.getURL("screenRecordingUrl") + "/files",
                agentId: String(agentData?.agentUniqId ?? ''),
                userName: agentData?.customer ?? '',
                agentName: agentData?.agentInfo?.agentId ?? '',
                userTimeZone: agentData?.agentInfo?.user?.userTimezone,
                recordingMode,
                quality:0.5,
                'onEnded': () => {
                    console.log("screen->Recording :: screen share stopped from system");
                    store.dispatch(setScreenRecording(false));
                    let screenRecordMandatory = !Boolean(callControlsJsonList()?.not_enforce_screen_record);
                    if (screenRecordMandatory) {
                        store.dispatch(setScreenRecordCancelled(true));
                    }
                },
                "onStart": function () {
                    console.log("screen->Recording :: recording-------started ---------");
                    store.dispatch(setScreenRecording(true));
                    const currentMode = getScreenRecordingMode();
                    const isCallActive = store.getState().call.isCallActivityPresent;
                    if (currentMode === 'ucid' && !isCallActive) {
                        console.log("recordingMode is", currentMode, "so pausing the recording");
                        setTimeout(() => {
                            finalRecording("login", "pause");
                        }, 500);
                    }
                }
            });
            registerAgentMonitorSdk(sdk);
            // sdk.start();
        }
    }, []);
    useEffect(() => {
        if (isScreenRecordingEnabledByApp) {
            console.log("screen->Recording :: ROLE_SCREEN_RECORDING, isAgantScreenRecordingEnabled  ,isUcidRecordingMode, SCREEN_RECORD_BY_APP , isScreenRecordingEnabledByApp value--->", ROLE_SCREEN_RECORDING, isAgantScreenRecordingEnabled, isUcidRecordingMode(), SCREEN_RECORD_BY_APP, isScreenRecordingEnabledByApp)
        }
        if ((ROLE_SCREEN_RECORDING && isAgantScreenRecordingEnabled)
            && isUcidRecordingMode() && SCREEN_RECORD_BY_APP && isScreenRecordingEnabledByApp) {
                console.log("screen recording : pause bargin only");
            setTimeout(() => {
                finalRecording('agentReleaseByAdmin', 'pause');
            }, 1500);
        }
    }, [isScreenRecordingEnabledByApp])

    useEffect(() => {
        if (isSettingEnabled("CAPTURE_MS_CLRTY") && app.msClarityProjectID) {
            Clarity.init(app.msClarityProjectID);
            Clarity.identify(getAgentData().agentInfo.agentId);
        }
        const handleOnline = () => {
            Logger.info("internet connected...");
            INTERNET_CHECK_ALERT && showSuccessNotification('Internet Connected Successfully');
            WSocketService.updateInternetStatus(true);
            // setTimeout(()=>{     
              WSocketService.startHeartbeatService();
            // },[1000])
        }
        const handleOffline = () => {
            Logger.info("internet connection lost...");
            INTERNET_CHECK_ALERT && showErrorNotification('Application Connection Lost. Retrying to Connect');
            WSocketService.updateInternetStatus(false);
            WSocketService.stopHeartbeatService();
        }

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    const navigateHome = () => {
        console.log("navigateHome --> navigating to login");
        navigate({
            pathname: "/login",
            search: window.location.search.replace(/[\\?|&]?(action=formLogin)/ig, ""),
            hash: window.location.hash
        });
    }

    const handleLocalStorageValues = () => {
        let tabsList = LocalStorageService.getItem("DashboardTabs")
        let DashboardActiveTab = LocalStorageService.getItem('DashboardActiveTab')
        let homePageLogo = LocalStorageService.getItem('homePageLogo')
        if (tabsList) {
            let data = tabsList.split(',')
            store.dispatch(setVisibleTabs(data));
        }
        if (DashboardActiveTab) {
            store.dispatch(setActiveTab(DashboardActiveTab));
        }
        if (homePageLogo) {
            store.dispatch(setHomePageLogo(homePageLogo))
        }
    }

    useEffect(() => {
        let reconnect = localStorage.getItem('reconnect');
        if (reconnect === 'true') {
            handleLocalStorageValues();
            handleScreenRecording("reconnect", "start");
        }
    }, []);

    useEffect(() => {
        //to handle toolbar refresh and reload
        if (WSocketService.isSocketClosed() && !WSocketService.isSocketConnecting()) {  // calling if web socket connection closed 
            WSocketService.checkSession()
        }
    }, [])

    useEffect(() => {
        if (agentLogoffByAdmin) {
            handleAgentLogoffByAdmin({ navigateHome });
        }
    }, [agentLogoffByAdmin]);

    useEffect(() => {
        if (parentRef?.current) {
            try {
                const parentRect = parentRef.current.getBoundingClientRect();
                const elemWidth = 200;
                const elemHeight = 44;

                setPosition({
                    x: parentRect.width - elemWidth,
                    y: parentRect.height - elemHeight,
                });
            } catch (e) {
                console.log("Error: while calculating element position on minimized screen during dragging");
            }
        }
    }, []);

    // This useEffect will handle the dragging events on the window
    useEffect(() => {
        const handleMouseMove = (e) => {
            try {
                if (!isDragging || !parentRef.current) return;
                const parentRect = parentRef.current.getBoundingClientRect();
                const elemWidth = 200;
                const elemHeight = 44;

                let newX = e.clientX - startPosition.x;
                let newY = e.clientY - startPosition.y;

                newX = Math.max(0, Math.min(newX, parentRect.width - elemWidth));
                newY = Math.max(0, Math.min(newY, parentRect.height - elemHeight));

                setPosition({ x: newX, y: newY });
            } catch (e) {
                console.log("Error: while calculating element position on minimized screen during dragging");
            }
        };

        const handleMouseUp = () => {
            setIsDragging(false);
        };
        if (isDragging) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        }
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };

    }, [isDragging, startPosition]);

    const handleMouseDown = (e) => {
        e.preventDefault();
        setIsDragging(true);
        setStartPosition({
            x: e.clientX - position.x,
            y: e.clientY - position.y,
        });
    };
    return (
        <div className={`oz-agent-toolbar-home ${isDragging ? "oz-dragging p-relative" : ""}`} ref={parentRef}>
            <Suspense fallback={<Loader loading={true} />}>
                <NavigatorBinder />
                <CallAudioElements />
                <PostScreenPop />
                <StatusBar />
                <Loader />
                <div className='oz-agent-toolbar'>
                    <div style={{ position: 'relative' }}>
                        <SideNav />
                        {isTbMinimized && <TBMinimizer />}
                    </div>

                    <div className={isTbMinimized ? 'oz-agent-toolbar-main-disabled' : 'oz-agent-toolbar-main'}>
                        <div style={{ position: 'relative' }}>
                            <ModesList />
                            <TBMinimizer />
                        </div>
                        <DynamicContainer />
                        {AGENT_SUB_USER_CHAT && <ChatApp />}
                    </div>
                    <DashboardTabs />
                </div>
                {isTbMinimized && position && <div
                    style={{
                        position: 'absolute',
                        top: position.y + 'px',
                        left: position.x + 'px',
                        cursor: isDragging ? 'grabbing' : 'grab',
                        width: '200px',
                        height: '100px',
                    }}
                    onMouseDown={handleMouseDown}
                ><MinimizedCallView isTbMinimized={isTbMinimized} />
                </div>}
                {/* } */}
            </Suspense >
        </div >
    )
}

export default Toolbar;